import { Injectable } from '@angular/core';
import { BarcodeScannerEnum } from './enum/barcode-scanner.enum';
import { IActionState } from '../../core/interfaces/action-data-state.interface';
import { Observable, Subject } from 'rxjs';

@Injectable()
export class BarcodeScannerService {
  private barcodeScannerActionSubject: Subject<IActionState<BarcodeScannerEnum, any>> = new Subject<IActionState<BarcodeScannerEnum, any>>();
  public barcodeScannerAction$: Observable<IActionState<BarcodeScannerEnum, any>> = this.barcodeScannerActionSubject.asObservable();

  public setBarcodeScannerAction(actionState: IActionState<BarcodeScannerEnum, any>): void {
    this.barcodeScannerActionSubject.next(actionState);
  }
}



// WEBPACK FOOTER //
// ./src/app/utils/barcode-scanner/barcode-scanner.service.ts